import { render, staticRenderFns } from "./rotationList.vue?vue&type=template&id=1350fdbc&"
import script from "./rotationList.vue?vue&type=script&lang=js&"
export * from "./rotationList.vue?vue&type=script&lang=js&"
import style0 from "./rotationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports